import {
    STENCIL_ROUTE_LOADER_DELAY_MS,
    STENCIL_ROUTE_LOADER_MIN_VISIBLE_MS,
} from './stencil-route-transition.constants';

export const calculateRemainingStencilLoaderVisibleTime = (elapsed: number, visibleElapsed: number): number =>
    elapsed >= STENCIL_ROUTE_LOADER_DELAY_MS ? Math.max(0, STENCIL_ROUTE_LOADER_MIN_VISIBLE_MS - visibleElapsed) : 0;
